import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CartValidationFacade } from '@spartacus/cart/base/root';
import { ICON_TYPE, IconComponent } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'cx-cart-item-validation-warning',
    templateUrl: './cart-item-validation-warning.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, AsyncPipe, TranslatePipe]
})
export class Ubxb2bCartItemValidationWarningComponent {
  @Input()
  code!: string;

  iconTypes = ICON_TYPE;
  isVisible = true;

  cartModification$ = this.cartValidationFacade
    .getValidationResults()
    .pipe(
      map((modificationList) =>
        modificationList.find((modification) => modification.entry?.product?.code === this.code)
      )
    );

  constructor(protected cartValidationFacade: CartValidationFacade) {}
}
